import React, { useEffect, useState } from 'react';

import SupplierContractReportsIndexTableRow from './SupplierContractReportsIndexTableRow';

import Button from 'CommonComponents/Button';
import PaginationInfo from 'CommonComponents/PaginationInfo';
import TablePagination from 'CommonComponents/TablePagination';
import TableSearchInput from 'CommonComponents/TableSearchInput';

export default function SupplierContractReportsIndexTable(props) {
    const [supplierContracts, setSupplierContracts] = useState([]);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [to, setTo] = useState(1);
    const [from, setFrom] = useState(1);
    const [total, setTotal] = useState(1);
    const [isLoading, setIsLoading] = useState({});
    const [searchValue, setSearchValue] = useState('');
    const [currentContract, setCurrentContract] = useState(null);

    useEffect(() => {
        fetchSupplierContracts();
    }, []);

    const defaultUrl = props.supplierContractReportsIndexUrl + '?per_page=' + perPage;

    const combineFetchUrl = (p = null, pp = null) => {
        return (
            props.supplierContractReportsIndexUrl +
            '?per_page=' +
            (pp || perPage) +
            '&page=' +
            (p || page) +
            (searchValue.length > 0 ? '&search=' + searchValue : '')
        );
    };

    const fetchSupplierContracts = (url = null) => {
        setIsLoading(true);
        const fetchUrl = url || defaultUrl;

        axios
            .get(fetchUrl)
            .then((res) => {
                const { data, to, from, total, last_page } = res.data;
                setSupplierContracts(data);
                setTo(to);
                setFrom(from);
                setTotal(total);
                setLastPage(last_page);
                setIsLoading(false);
            })
            .catch((error) => {
                setSupplierContracts([]);
                setIsLoading(false);
            });
    };

    function pageChange(data) {
        const url = combineFetchUrl(data.selected + 1);
        setPage(+data.selected + 1);
        fetchSupplierContracts(url);
    }

    const handleChange = (event) => {
        setSearchValue(event.target.value);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            const url = combineFetchUrl(1);
            setPage(1);
            fetchSupplierContracts(url);
            event.preventDefault();
        }
    };

    const loading = (key, value = true) => {
        setIsLoading((pervLoading) => ({ ...pervLoading, [key]: value }));
    };

    return (
        <div className="table__card">
            <div className="tw-flex tw-items-end tw-justify-between tw-mb-6">
                <div>
                    <h5 className="table__header">{$t('Supplier Contract Reports')}</h5>
                    <div className="table__pagination-info">
                        <PaginationInfo to={to} from={from} total={total} />
                        <TablePagination lastPage={lastPage} pageChange={pageChange} />
                    </div>
                </div>
                <div className="tw-flex tw-gap-x-1.5">
                    <TableSearchInput searchValue={searchValue} handleChange={handleChange} handleKeyPress={handleKeyPress} />
                    <form method="POST" action={generateUrl}>
                        <input type="hidden" name="_token" value={csrfToken} />
                        <Button type="submit" variant="primary">
                            {$t('Generate Report')}
                        </Button>
                    </form>
                </div>
            </div>
            <div className="inbud-table_wrapper">
                <table className="inbud-table tw-table-fixed">
                    <thead>
                        <tr>
                            <th className="tw-w-40">{$t('Supplier Name')}</th>
                            <th className="tw-w-40">{$t('Supplier Code')}</th>
                            <th className="tw-w-40">{$t('Contract Reference')}</th>
                            <th className="tw-w-40">{$t('Contract Value')}</th>
                            <th className="tw-w-40">{$t('Contract Start')}</th>
                            <th className="tw-w-40">{$t('Contract End')}</th>
                            <th className="tw-w-40">{$t('Contact Name')}</th>
                            <th className="tw-w-40">{$t('Contact Email')}</th>
                            <th className="tw-w-40">{$t('Milestone Type')}</th>
                            <th className="tw-w-40">{$t('Description')}</th>
                            <th className="tw-w-40">{$t('Due date')}</th>
                            <th className="tw-w-40">{$t('Forecast Due Date')}</th>
                            <th className="tw-w-40">{$t('Completed Date')}</th>
                            <th className="tw-w-40">{$t('Amount')}</th>
                            <th className="tw-w-40">{$t('Contract Owner')}</th>
                        </tr>
                    </thead>
                    {!isLoading.supplier_contracts && supplierContracts.length > 0 && (
                        <tbody>
                            {supplierContracts.map((supplierContract) => {
                                return <SupplierContractReportsIndexTableRow key={supplierContract.id} supplierContract={supplierContract} />;
                            })}
                        </tbody>
                    )}
                    {isLoading.supplier_contracts && (
                        <tbody>
                            <tr>
                                <td colSpan="15">{$t('Loading')}...</td>
                            </tr>
                        </tbody>
                    )}
                    {!isLoading.supplier_contracts && supplierContracts.length === 0 && (
                        <tbody>
                            <tr>
                                <td colSpan="15">{$t('No Contracts found, you can add Contracts Assigning them to Committed Expenditures')}</td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    );
}
